import Area from '@/components/Area';
import { OrbitControls, Preload, useTexture } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import * as React from 'react';
import * as THREE from 'three';
import imgOutSide from './2294472375_24a3b8ef46_o.jpg.chunk';
import imgInside from './Photosphere1.jpg.chunk';

type StoreItem = {
  name: string;
  color: string;
  position: [number, number, number];
  url: string;
  link: number;
};

const store: StoreItem[] = [
  { name: 'outside', color: 'lightpink', position: [10, 0, -15], url: imgOutSide, link: 1 },
  { name: 'inside', color: 'lightblue', position: [15, 0, 0], url: imgInside, link: 0 },
  // ...
];

type DomeProps = {
  name: string;
  position: [number, number, number];
  texture: THREE.Texture;
  onClick: () => void;
};

function Dome({ texture }: DomeProps) {
  return (
    <group>
      <mesh>
        <sphereGeometry args={[500, 60, 40]} />
        <meshBasicMaterial map={texture} side={THREE.BackSide} />
      </mesh>
    </group>
  );
}

function Portals() {
  const [which, setWhich] = React.useState(0);
  const { link, ...props } = store[which];
  const maps = useTexture(store.map((s) => s.url));
  return <Dome onClick={() => setWhich(link)} {...props} texture={maps[which]} />;
}

export type Props = {};

function App01(props: Props) {
  const {} = props;

  return (
    <Area>
      {() => (
        <Canvas frameloop="demand" camera={{ position: [0, 0, 800] }}>
          <OrbitControls />
          <React.Suspense>
            <Preload all />
            <Portals />
          </React.Suspense>
        </Canvas>
      )}
    </Area>
  );
}

export default React.memo(App01);
